import { render, staticRenderFns } from "./TeamsPagination.vue?vue&type=template&id=57470e3e&scoped=true&"
import script from "./TeamsPagination.vue?vue&type=script&lang=js&"
export * from "./TeamsPagination.vue?vue&type=script&lang=js&"
import style0 from "./TeamsPagination.vue?vue&type=style&index=0&id=57470e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57470e3e",
  null
  
)

export default component.exports